import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import WorkCarousel from '../WorkCarousel/WorkCarousel'
import { useSubServiceData } from '../../hooks/useSubServiceData'

const WorkSubServiceBlock = () => {
  const { slug, subSlug } = useParams()
  const { data: subService, isLoading } = useSubServiceData(slug, subSlug)

  const items = useMemo(() => {
    const pairs = subService?.beforeAfter
    if (!pairs || pairs.length === 0) return []
    const title = subService?.title || 'автомобиля'
    return [...pairs]
      .sort((a, b) => a.order - b.order)
      .map((pair, i) => ({
        id: `work-subservice-${i}`,
        beforeSrc: pair.beforeImage,
        afterSrc: pair.afterImage,
        altBefore: `До — ${title}`,
        altAfter: `После — ${title}`,
      }))
  }, [subService])

  return (
    <WorkCarousel
      title="Работы до и после"
      items={items}
      isLoading={isLoading}
      footerDescription="Короткая визуальная демонстрация результата до и после работ."
    />
  )
}

export default WorkSubServiceBlock
